var StatusModule = /** @class */ (function () {
    function StatusModule() {
    }
    return StatusModule;
}());
export { StatusModule };
